import * as React from 'react';
import styled from 'styled-components';
import { IReportOption } from '../../../../data/providers/reports/reportOptions';
import {
  IReportSettings,
  selectedReportSettingProvider,
} from '../../../../data/providers/settings/reports/selectedReportSettingProvider';
import { Entity, EntityType } from '../../../../data/types';
import { updateSelectedReport } from '../../../../data/writers/settings/reports/selectedReportSetting';
import { FullHeightColumn } from '../../../layout/Column';
import { ScrollableArea } from '../../../layout/ScrollableArea';
import { ReportMenu } from '../../../reports/ReportMenu';
import { Reports } from '../../../reports/Reports';
import { ReportSettings } from '../../../reports/ReportSettings';
import { EPdfMode } from '../../../shared/pdf/Pdf';
import { PdfStateToggle } from '../../../shared/pdf/PdfStateToggle';

interface IProps {
  entity: Entity;
  entityType: EntityType;
}

export const Analyze = (props: IProps): React.ReactElement => {
  const [selectedReport, setSelectedReport] = React.useState<IReportOption>();
  const [pdfMode, setPdfMode] = React.useState<EPdfMode>(EPdfMode.DEFAULT);
  const [loading, setLoading] = React.useState<boolean>(true);

  /**
   * @description subscribe to the selected report setting
   */
  React.useEffect((): (() => void) => {
    const subscriber = selectedReportSettingProvider().subscribe(
      (settings: IReportSettings): void => {
        setSelectedReport(settings.report);
      }
    );
    return (): void => subscriber.unsubscribe();
  }, []);

  /**
   * @description handles change to the selected report
   */
  const reportChangeHandler = (report: IReportOption): void => {
    setLoading(true);
    updateSelectedReport(report);
    setSelectedReport(report);
  };

  return (
    <FullHeightColumn>
      <ReportMenu
        selected={selectedReport}
        onReportSelected={reportChangeHandler}
        entityType={props.entityType}
      />
      <ScrollableArea
        style={{
          backgroundColor: 'var(--color-surface-0)',
        }}
      >
        <Reports
          entity={props.entity}
          loading={loading}
          setLoading={setLoading}
          entityType={props.entityType}
          report={selectedReport}
          pdfMode={pdfMode}
          onPdfModeChange={setPdfMode}
        />
      </ScrollableArea>
      <Footer>
        <ReportSettings report={selectedReport} setLoading={setLoading} />
        <PdfToggleWrapper>
          <PdfStateToggle value={pdfMode} onChange={setPdfMode} />
        </PdfToggleWrapper>
      </Footer>
    </FullHeightColumn>
  );
};

const Footer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
`;

const PdfToggleWrapper = styled.div`
  position: absolute;
  right: 10px;
`;
